import Badges from './badges'
import cSwitch from './switch'
import Steps from './steps'
import VueDatepickerLocal from './vue-datepicker-local'
import FullCalendar from './vue-full-calendar'
import Scale from './scale'
import Rate from './rate'
import EmptyHint from './empty-hint'
import PromptBox from './prompt-box'
import RadioGroupSub from './filter-group'
import RadioGroup from './radio-group'
import SubmitButton from './submit-button'
import OperatingButton from './operating-button'
import BusTable from './table'
import ugcUploader from './up-video'
import SortableList from './drag-sort/fixed-label'
import SortableItem from './drag-sort/drag-label'
import ScreeningSearch from './screen-search'
import WSkeleton from './skeleton'
import IsLoading from './loading'
import Multiselect from './vue-multiselect'

export default {
  Badges,
  cSwitch,
  Steps,
  VueDatepickerLocal,
  FullCalendar,
  OperatingButton,
  Scale,
  Rate,
  EmptyHint,
  PromptBox,
  RadioGroupSub,
  RadioGroup,
  BusTable,
  ugcUploader,
  SortableList,
  SortableItem,
  ScreeningSearch,
  SubmitButton,
  WSkeleton,
  IsLoading,
  Multiselect
}



// WEBPACK FOOTER //
// ./src/components-base/components-custom/index.js